<template>
  <insight :insight="insight"
           animation-name="Expense.json"
           :button-text="'לפרטים נוספים'"
           :button-action="buttonAction">
    <template v-slot:insight-text>
      <div>המערכת זיהתה הוצאה חריגה של
        <span class="amount">{{ formattedAmount }} ₪</span> <span class="bold">והוציאה אותה מהתזרים</span>
      </div>
    </template>
  </insight>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import moneyUtils from '@/utils/money';
import HighExpenseExclusionPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/insights/components/HighExpenseExclusionPopup.vue';
import Insight from './components/Insight';

export default {
  name: 'HighExpenseInsight',
  components: {
    Insight,
  },
  props: {
    insight: { type: Object },
  },
  computed: {
    ...mapGetters('cashflowView', ['excluded']),
    formattedAmount() {
      return moneyUtils.formatAmountWithFraction(this.insight.billingAmount, 0);
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    ...mapActions('insights', ['clearInsight']),
    buttonAction() {
      this.openModal(
        {
          component: HighExpenseExclusionPopup,
          props: {
            transaction: this.insight,
            insight: this.insight,
          },
        },
      );
    },
  },
  watch: {
    excluded(newValue) {
      const stillExcludedHighIncome = _.chain(newValue)
        .filter(item => item.excludeReason === 'highExpenseExclusion' || item.excludeReason === 'relativeExpenseExclusion')
        .some({ transactionId: this.insight.transactionId })
        .value();
      if (!stillExcludedHighIncome) {
        this.clearInsight(this.insight);
      }
    },
  }
  ,
};
</script>

<style lang="scss" scoped>
.amount {
  white-space: pre;
}

.bold {
  font-weight: bold;
}
</style>
